var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificaciones = function SvgNotificaciones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "notificaciones_svg__Capa_2",
    viewBox: "0 0 27.76 30.87"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notificaciones_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.39 21.45c-4.13 0-3.07-8.58-3.82-13.23S18.34 0 13.88 0C9.41 0 5.94 3.57 5.19 8.22s.31 13.23-3.82 13.23c-.76 0-1.37.65-1.37 1.44v.52c0 .63.49 1.15 1.09 1.15h25.58c.6 0 1.09-.51 1.09-1.15v-.52c0-.8-.61-1.44-1.37-1.44M13.88 30.87c2.42 0 4.44-1.68 4.97-3.93H8.91a5.106 5.106 0 0 0 4.97 3.93",
    fill: "#eafbf9"
  }))));
};
export default SvgNotificaciones;